export const GET_COUNTRY_YEAR_GROUPS_REQUEST = 'GET_COUNTRY_YEAR_GROUPS_REQUEST';
export const GET_COUNTRY_YEAR_GROUPS_SUCCESS = 'GET_COUNTRY_YEAR_GROUPS_SUCCESS';
export const GET_COUNTRY_YEAR_GROUPS_FAILURE = 'GET_COUNTRY_YEAR_GROUPS_FAILURE';

export const getCountryYearGroupRequest = (countryCode, success, failure) =>
    ({ type: GET_COUNTRY_YEAR_GROUPS_REQUEST, countryCode, success, failure, countryCourses: [] });

export const getCountryYearGroupSuccess = yearGroups =>
    ({ type: GET_COUNTRY_YEAR_GROUPS_SUCCESS, isLoadingCountryCourses: false, yearGroups });

export const getCountryYearGroupFailure = () =>
    ({ type: GET_COUNTRY_YEAR_GROUPS_FAILURE, isLoadingCountryCourses: false });

export const CLEAR_COURSE_LIST = 'CLEAR_COURSE_LIST';

export const clearCourseList = () =>
    ({ type: CLEAR_COURSE_LIST, productCourses: [] });

export const DESELECT_COURSE = 'DESELECT_COURSE';

export const deselectCourses = (deselectCourse = true) =>
    ({ type: DESELECT_COURSE, deselectCourse });

export const GET_YEAR_GROUP_REQUEST = 'GET_YEAR_GROUP_REQUEST';
export const GET_YEAR_GROUP_SUCCESS = 'GET_YEAR_GROUP_SUCCESS';
export const GET_YEAR_GROUP_FAILURE = 'GET_YEAR_GROUP_FAILURE';

export const getYearGroup = () =>
    ({ type: GET_YEAR_GROUP_REQUEST });

export const getYearGroupSuccess = ({ data }) =>
    ({ type: GET_YEAR_GROUP_SUCCESS, data });

export const getYearGroupFailure = () =>
    ({ type: GET_YEAR_GROUP_FAILURE });

export const GET_COUNTRY_REQUEST = 'GET_COUNTRY_REQUEST';
export const GET_COUNTRY_SUCCESS = 'GET_COUNTRY_SUCCESS';
export const GET_COUNTRY_FAILURE = 'GET_COUNTRY_FAILURE';

export const getCourseCountry = selectedProductId =>
    ({ type: GET_COUNTRY_REQUEST, selectedProductId });

export const getCourseCountrySuccess = data =>
    ({ type: GET_COUNTRY_SUCCESS, data });

export const getCourseCountryFailure = () =>
    ({ type: GET_COUNTRY_FAILURE });

export const GET_UPF_COUNTRY_REQUEST = 'GET_UPF_COUNTRY_REQUEST';
export const GET_UPF_COUNTRY_SUCCESS = 'GET_UPF_COUNTRY_SUCCESS';
export const GET_UPF_COUNTRY_FAILURE = 'GET_UPF_COUNTRY_FAILURE';

export const getUpfCourseCountry = selectedProductId =>
    ({ type: GET_UPF_COUNTRY_REQUEST, selectedProductId });

export const getUpfCourseCountrySuccess = data =>
    ({ type: GET_UPF_COUNTRY_SUCCESS, data });

export const getUpfCourseCountryFailure = () =>
    ({ type: GET_UPF_COUNTRY_FAILURE });

export const GET_PRODUCT_COURSE_REQUEST = 'GET_PRODUCT_COURSE_REQUEST';
export const GET_PRODUCT_COURSE_SUCCESS = 'GET_PRODUCT_COURSE_SUCCESS';
export const GET_PRODUCT_COURSE_FAILURE = 'GET_PRODUCT_COURSE_FAILURE';

export const getProductCourse = (countryCode, productId, yearGroup) =>
    ({ type: GET_PRODUCT_COURSE_REQUEST, countryCode, productId, yearGroup, isProductCoursesLoaded: false, isProductCoursesFetching: true });

export const getProductCourseSuccess = data =>
    ({ type: GET_PRODUCT_COURSE_SUCCESS, data, isProductCoursesLoaded: true, isProductCoursesFetching: false });

export const getProductCourseFailure = () =>
    ({ type: GET_PRODUCT_COURSE_FAILURE, isProductCoursesLoaded: true, isProductCoursesFetching: false });

export const GET_SCHOOL_COURSE_REQUEST = 'GET_SCHOOL_COURSE_REQUEST';
export const GET_SCHOOL_COURSE_SUCCESS = 'GET_SCHOOL_COURSE_SUCCESS';
export const GET_SCHOOL_COURSE_FAILURE = 'GET_SCHOOL_COURSE_FAILURE';

export const getSchoolCourse = yearGroup =>
    ({ type: GET_SCHOOL_COURSE_REQUEST, yearGroup });

export const getSchoolCourseSuccess = data =>
    ({ type: GET_SCHOOL_COURSE_SUCCESS, data });

export const getSchoolCourseFailure = () =>
    ({ type: GET_SCHOOL_COURSE_FAILURE });




// WEBPACK FOOTER //
// ./app/containers/assign-courses/actions.js